import React, { useContext, useEffect, useState } from 'react';

import {
  Grid,
  Typography,
} from '@material-ui/core';

import {
  useHistory,
  useParams,
  withRouter,
} from 'react-router-dom';

import PropTypes from 'prop-types';

import BreadCrumb from '../../fields/breadCrumb';
import SchedulesList from '../../fields/schedulesList';
import Footer from '../../fields/footer';
import Header from '../../fields/header';
import MenuDrawer from '../../fields/menuDrawer';
import SpinnerLoading from '../../feedback/spinnerLoading';

import { getClinicianEnrolments, getEnrolmentSchedules, getClinicianInfo, getAllSchedulingPatterns, modifyUserSchedule } from '../../../utils/comms';

import translations from '../../../languages/i18n';

import generalStyles from '../../../styles/generalStyles';
import { sectionTitle } from '../../../styles/formElementsStyles';

// NOTA: Per poder emprar el react-router-dom i enllaçar pàgines s'ha de convertir el component en una funció i exportar-lo embolicat per withRouter
// En cas de que el component sigui un fill directe de Route no fa falta fer-ho
// Explicat al punt 2.1. Using withRouter de https://dev.to/projectescape/programmatic-navigation-in-react-3p1l

import { SessionContext } from '../../../utils/context';

function ListClinicianSchedules({ lang, handleChangeLang }) {
  const { idClinician } = useParams();
  const sessionContext = useContext(SessionContext);
  const [clinician, setClinician] = useState({});
  const [schedulesList, setSchedulesList] = useState([]);
  const [showDrawer, setShowDrawer] = useState(false);
  const [showLoading, setShowLoading] = useState(false);

  const history = useHistory();
  const classes = generalStyles();
  const sectionTitleStyle = sectionTitle();

  const getCliniciansFromServer = async () => {
    setShowLoading(true);
    let clinicianUsername = '';
    const clinicianInfo = await getClinicianInfo(idClinician, sessionContext.userToken);
    if (clinicianInfo.status === 200) {
      clinicianUsername = clinicianInfo.data.clinician.username;
      setClinician(clinicianInfo.data.clinician);
    } else if (clinicianInfo === 400) { // Error amb les dades
      console.log('Error 400 obtenint els pacients');
    } else { // Login KO. Altres errors
      console.log(clinicianInfo);
    }

    // Obtenim els enrolments que tenen al clinic que consulta la web al seu equip i indicam a quins es supervisor
    let clinicianEnrolments = [];
    const clinicianEnrolmentsFromServer = await getClinicianEnrolments(sessionContext.userId, sessionContext.userToken);
    if (clinicianEnrolmentsFromServer.status === 200) {
      clinicianEnrolments = clinicianEnrolmentsFromServer.data.enrolments.map((enrolment) => {
        const supervised = enrolment.supervisedBy.some((member) => member.admin && member.clinician === sessionContext.userId);
        return ({ enrolmentId: enrolment._id, patient: enrolment.patient.username, supervised });
      });
    } else if (clinicianEnrolmentsFromServer === 400) { // Error amb les dades
      console.log('Error 400 obtenint els enrolments del clinic');
    } else { // Login KO. Altres errors
      console.log(clinicianEnrolmentsFromServer);
    }

    const schedulingPatterns = await getAllSchedulingPatterns(sessionContext.userToken);
    if (schedulingPatterns.status === 200) {
      const enrolmentsFromServer = await getClinicianEnrolments(idClinician, sessionContext.userToken); // Consulta els enrolments d'un clinic en concret (ALERTA: no té per que ser el clínci que consulta la web)
      if (enrolmentsFromServer.status === 200) { // Tenim llistat enrolments
        // per cada enrolment obtenir schedules
        const schedules = [];
        await Promise.all(enrolmentsFromServer.data.enrolments.map(
          async (enrolment) => {
            const schedulesFromServer = await getEnrolmentSchedules(enrolment._id, sessionContext.userToken);
            if (schedulesFromServer.status === 200) {
                schedulesFromServer.data.userSchedules.map((item) => {
                // Filtram el llistat de formularis. getEnrolmentSchedules torna tots els formularis (tant de pacients com de clinics), al llistat només volem mostar els formularis d'un clinic en concret
                // if (item.role === 'Clinician') {
                // Si al llistat s'han de mostrar els formularis de tots els clínics, emprar la condició anterior
                if (item.username === clinicianUsername) {
                  let myScheduling = null;
                  if (item.schedulingPattern) {
                    myScheduling = schedulingPatterns.data.schedulingPatterns.filter((element) => element._id === item.schedulingPattern);
                  }
                  // TODO: comprovar si fa falta posar l'else a aquest if igual com està a listPatientSchedules.js (mirar si getEnrolmentsSchedules i getPatientUserSchedules tornen el mateix)
                  const editableByClinician = clinicianEnrolments.some((enrol) => enrol.supervised && enrol.enrolmentId === item.enrolment);
                  const enrolInfo = clinicianEnrolments.find((enrol) => enrol.enrolmentId === item.enrolment);
                  const patientUserName = enrolInfo ? enrolInfo.patient : '';
                  schedules.push({
                    ...item,
                    programName: enrolment.program.sharedId,
                    scheduleName: myScheduling !== null ? myScheduling[0].desc : item.name,
                    editableByClinician,
                    patientUserName,
                  });
                }
              });
            } else if (schedulesFromServer === 400) { // Error amb les dades
              console.log('Error 400 obtenint els getEnrolmentSchedules');
            } else { // Login KO. Altres errors
              console.log(schedulesFromServer);
            }
          },
        ));
        setSchedulesList(schedules);
      } else if (enrolmentsFromServer === 400) { // Error amb les dades
        console.log('Error 400 obtenint els pacients');
      } else { // Login KO. Altres errors
        console.log(enrolmentsFromServer);
      }
    } else if (schedulingPatterns === 400) { // Error amb les dades
      console.log('Error 400 obtenint els pacients');
    } else { // Login KO. Altres errors
      console.log(schedulingPatterns);
    }
    setShowLoading(false);
  };

  useEffect(() => {
    getCliniciansFromServer();
  }, [idClinician]);

  const gotoScreen = (screen) => {
    history.push(`/${sessionContext.role.toLowerCase()}/${screen}`);
  };

  const showMenuDrawer = (show) => {
    setShowDrawer(show);
  };

  const changeUserSchedule = (out, idSchedule, token) => {
    (async () => {
      const putResponse = await modifyUserSchedule(out, idSchedule, token);
      if (putResponse.status === 200) {
        getCliniciansFromServer();
      } else if (putResponse === 400) { // Error amb les dades
        console.log('Error 400 modificant UserSchedule');
      } else { // Login KO. Altres errors
        console.log(putResponse);
      }
    })();
  };


  return (
    <div className={classes.content}>
      <SpinnerLoading show={showLoading} />
      {/* ATENCIÓ: el role ve del servidor amb la primera lletra en majuscula, jo ho necessit tot en minuscula */}
      <Header type={sessionContext.role.toLowerCase()} handleShowDrawer={(show) => showMenuDrawer(show)} lang={lang} handleChangeLang={handleChangeLang}/>
      <MenuDrawer
        type={sessionContext.role.toLowerCase()}
        showDrawer={showDrawer}
        handleShowDrawer={(show) => showMenuDrawer(show)}
        handleGotoScreen={(screen) => gotoScreen(screen)}
      />
      <div className={classes.body}>
        <Grid container direction='column' spacing={2}>
          {/* ----------------------- Fila 0 ----------------------- */}
          <Grid item xs={12}>
            <BreadCrumb role={sessionContext.role.toLowerCase()} home='listClinicians' lang={lang} />
          </Grid>
          {/* ----------------------- Fila 1 ----------------------- */}
          <Grid item className={sectionTitleStyle.root}>
            <Grid container justify='space-between' spacing={2}>
              <Grid item>
                <Typography variant='h4' component='div' className={sectionTitleStyle.title}>
                  {`${translations['_clinicianForms']} ${clinician.username}`}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          {/* ----------------------- Fila 2 ----------------------- */}
          <Grid item>
            <Grid container justify='space-between' spacing={2}>
              <Grid item xs={12}>
                <SchedulesList
                  editScheduleData={changeUserSchedule}
                  schedulesData={schedulesList}
                  userInfo={clinician}
                  userType='clinician'
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </div>
      <Footer />
    </div>
  );
}

export default withRouter(ListClinicianSchedules);

ListClinicianSchedules.propTypes = {
  lang: PropTypes.string.isRequired,
  handleChangeLang: PropTypes.func.isRequired,
};
